import { lazyLoad } from 'utils/loadable';

export const TooltipAdapter = lazyLoad(
  () => import('./index'),
  module => module.TooltipAdapter,
);
